module.exports = {
  text: `Голиафы могут быть полезными союзниками, но никогда не обращайтесь к ним за помощью, если Вы слабы. Они столь же тверды и неумолимы как горный камень, столь же холодны и безжалостны как жестокие, холодные ветры. Если Вы обращаются к ним, будучи в силе, они могут посчитать Вас достойным союза.`,
  author: 'Тордек, Путеводитель по горным пикам',
}
